import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/fd/account/group/list",
        component: List,
        name: "fd.account.group.list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/account/group/create",
        component: Create,
        name: "fd.account.group.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/account/group/barcode/edit",
        component: Edit,
        name: "fd.account.group.edit",
        meta: {
            requiresAuth: true,
        },
    },
    // { path: '/fd/account/group/item/view', component: View, name: 'fd.account.group.view'},
];
